<template>
  <div class="home">
    <el-card shadow="always">
      <el-form :inline="true">
        <el-form-item>
          <el-input
            v-model="filter"
            suffix-icon="el-icon-search"
            placeholder="Procurar por"
          ></el-input>
        </el-form-item>
        <el-form-item style="float: right">
          <el-button type="primary" @click="add">Novo Usuário</el-button>
        </el-form-item>
      </el-form>
    </el-card>
    <el-table
      :data="
        tableData.filter(
          data =>
            !filter ||
            data.name.toLowerCase().includes(filter.toLowerCase()) ||
            data.mail.toLowerCase().includes(filter.toLowerCase())
        )
      "
      height="70vh"
      style="width: 100%"
    >
      <el-table-column prop="name" label="Razão Social"></el-table-column>
      <el-table-column prop="mail" label="E-mail"></el-table-column>
      <el-table-column prop="active" label="Ativo">
        <template slot-scope="scope">{{
          scope.row.active ? "Sim" : "Não"
        }}</template>
      </el-table-column>
      <el-table-column prop="contact" label="Contato"> </el-table-column>
      <el-table-column prop="type" label="Tipo">
        <template slot-scope="scope">
          {{
            scope.row.type !== "1"
              ? scope.row.type !== "2"
                ? "Funcionário"
                : "Fornecedor"
              : "Administrador"
          }}
        </template>
      </el-table-column>
      <el-table-column
        prop="createdAt"
        label="Data Criação"
        :formatter="formatter"
      ></el-table-column>
      <el-table-column label="#">
        <template slot-scope="scope">
          <el-button size="mini" @click="edit(scope.row)">
            <i class="el-icon-edit"></i>
          </el-button>
          <el-button size="mini" type="danger" @click="remove(scope.row)">
            <i class="el-icon-delete"></i>
          </el-button>
          <el-button
            size="mini"
            type="warning"
            v-if="scope.row.active"
            @click="block(scope.row)"
          >
            <i class="el-icon-warning-outline"></i>
          </el-button>
          <el-button
            size="mini"
            type="success"
            v-if="!scope.row.active"
            @click="unblock(scope.row)"
          >
            <i class="el-icon-warning-outline"></i>
          </el-button>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import { UserTypeEnum, UserService } from "../services/users/user.services";
import { mapGetters } from "vuex";
import moment from "moment";

export default {
  name: "UsersView",
  components: {},
  data() {
    return {
      filter: "",
      tableData: []
    };
  },
  methods: {
    ...mapGetters("auth", ["getCompanyId"]),
    formatter(row) {
      return moment(row.createdAt).format("DD/MM/YYYY HH:mm:ss");
    },
    add: function() {
      const vm = this;
      vm.$router.push({ name: "user.add" });
    },
    edit: function(row) {
      const vm = this;
      vm.$router.replace({
        name: "user.edit",
        params: { id: row.id }
      });
    },
    remove: function(row) {
      const vm = this;
      this.$confirm(`Confirmar a eliminação do usuário ${row.name}?`, "Aviso", {
        confirmButtonText: "OK",
        cancelButtonText: "Cancelar",
        type: "Aviso",
        center: true
      }).then(() => {
        const loading = vm.$loading({
          lock: true,
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)"
        });
        UserService.delete(row.id)
          .then(() => {
            setTimeout(() => {
              vm.fetchRecords();
            }, 300);
            this.$message({
              type: "success",
              message: "Usuário eliminado com sucesso!"
            });
          })
          .catch(error => {
            vm.$notify.error({
              title: "Erro",
              message: error
            });
          })
          .finally(() => loading.close());
      });
    },
    block: function(row) {
      const vm = this;
      this.$confirm(
        `Deseja bloquear o acesso do usuário ${row.name}?`,
        "Aviso",
        {
          confirmButtonText: "OK",
          cancelButtonText: "Cancelar",
          type: "Aviso",
          center: true
        }
      ).then(() => {
        const loading = vm.$loading({
          lock: true,
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)"
        });
        UserService.block(row.id)
          .then(() => {
            setTimeout(() => {
              vm.fetchRecords();
            }, 500);
            this.$message({
              type: "success",
              message: "Usuário bloqueado com sucesso!"
            });
          })
          .catch(error => {
            vm.$notify.error({
              title: "Erro",
              message: error
            });
          })
          .finally(() => loading.close());
      });
    },

    unblock: function(row) {
      const vm = this;
      this.$confirm(
        `Deseja desbloquear o acesso do usuário ${row.name}?`,
        "Aviso",
        {
          confirmButtonText: "OK",
          cancelButtonText: "Cancelar",
          type: "Aviso",
          center: true
        }
      ).then(() => {
        const loading = vm.$loading({
          lock: true,
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)"
        });
        UserService.unblock(row.id)
          .then(() => {
            setTimeout(() => {
              vm.fetchRecords();
            }, 300);
            this.$message({
              type: "success",
              message: "Usuário desbloqueado com sucesso!"
            });
          })
          .catch(error => {
            vm.$notify.error({
              title: "Erro",
              message: error
            });
          })
          .finally(() => loading.close());
      });
    },

    fetchRecords: function() {
      const vm = this;
      const companyId = vm.getCompanyId();
      const loading = vm.$loading({
        lock: true,
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
      UserService.list({ companyId: companyId })
        .then(response => {
          vm.tableData = response.records;
        })
        .catch(error => {
          this.$message({
            type: "error",
            message: error
          });
        })
        .finally(() => loading.close());
    }
  },
  mounted() {
    const vm = this;
    UserService.me()
      .then(response => {
        if (
          response.user.type !== UserTypeEnum.ADMIN &&
          response.user.type !== UserTypeEnum.MASTER
        ) {
          return vm.$router.push({ name: "home" });
        }
        vm.fetchRecords();
      })
      .catch(() => {});
  }
};
</script>
